var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "booking-view myskov-orders" }, [
    _c("img", {
      staticStyle: { "border-style": "none" },
      attrs: { height: "1", width: "1", alt: "", src: _vm.googleAdService }
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "booking-view__body" },
      [
        _c("msg-block", { attrs: { type: "success" } }, [
          _c("p", [
            _c("b", [
              _vm._v(
                _vm._s(_vm.translations.msg_thank_you_title) +
                  " " +
                  _vm._s(_vm.tourOperatorName)
              )
            ])
          ]),
          _vm._v(" "),
          _c("p", {
            domProps: { innerHTML: _vm._s(_vm.translations.msg_thank_you_txt) }
          })
        ]),
        _vm._v(" "),
        _vm.order
          ? _c("order", {
              staticClass: "myskov-order-block--print",
              attrs: { order: _vm.order }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "link-block link-block--trustpilot" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "link-block__text" }, [
            _c("p", [
              _c("b", {
                domProps: {
                  textContent: _vm._s(_vm.translations.trustpilot_title)
                }
              })
            ]),
            _vm._v(" "),
            _c("p", {
              domProps: { innerHTML: _vm._s(_vm.translations.trustpilot_txt) }
            })
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "link-block__img" }, [
      _c("img", {
        attrs: {
          img: "",
          src: require("./../../img/logos/trustpilot-logo.svg"),
          alt: ""
        }
      })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b2170c82", { render: render, staticRenderFns: staticRenderFns })
  }
}